import type Cache from '@fs/zion-cache'
import { fetcher } from '../useSwrRequest'

export type WrappedResponse<T> = {
  status: string
  statusText: string
  message?: string
  data: T
  statuses?: TfStatus[]
}

export type TfStatus = {
  code: string
  message: string
  cause: string
}
/**
 * Reads wrapped data from tree-data backend that always returns with a 200 response and converts it to the format required by the frontend.
 */
export async function readWrappedData<T>(url: string, cache?: Cache): Promise<T | undefined> {
  const res = await fetcher<WrappedResponse<T>>(url, cache)
  return unwrappedResponse(res)
}

export function unwrappedResponse<T>(
  response: WrappedResponse<T> | undefined
): WrappedResponse<T> extends undefined ? undefined : T {
  if (response === undefined) return undefined as WrappedResponse<T> extends undefined ? undefined : T
  if (response.status !== 'OK') {
    // Formulate error so that it matches what useSwrRequest is expecting
    const error = new Error(response.message || response.statusText) as Error & {
      response: { status: number; message: string }
    }
    error.response = { status: 500, message: response.message || response.statusText }
    throw error
  }
  return response.data
}
